module.exports = __webpack_public_path__ + "static/media/edit.cb04316f.svg";